import { TelaDeLoja, VIRADA_DA_TELA_DE_LOJA } from '@/shareds/preferencia-da-tela-de-loja'
import { EscolhaDeVersao } from '@/shareds/versao-da-tela'

const dia = (data: Date) => data.toLocaleDateString('pt-BR')
// A virada é a meia-noite em que a nova passa a ser a padrão; o último dia da clássica como padrão é o anterior
const PRIMEIRO_DIA_DA_NOVA = dia(VIRADA_DA_TELA_DE_LOJA)
const ULTIMO_DIA_DA_CLASSICA = dia(new Date(
	VIRADA_DA_TELA_DE_LOJA.getFullYear(),
	VIRADA_DA_TELA_DE_LOJA.getMonth(),
	VIRADA_DA_TELA_DE_LOJA.getDate() - 1,
))

// Textos da convivência entre a tela clássica e a nova da loja. Somem junto com a tela clássica.
export const TEXTOS_DA_TROCA = {
	destaque: {
		titulo: 'Nova tela da loja',
		texto: `As abas viraram seções por assunto e a busca acha qualquer campo da loja. Troque quando quiser por este botão. A partir de ${PRIMEIRO_DIA_DA_NOVA}, a nova tela passa a ser a padrão.`,
	},
	avisoDaClassica: {
		titulo: 'Esta tela clássica não vai receber parâmetros novos.',
		corpo: 'Os parâmetros das próximas atualizações do sistema vão aparecer só na nova tela. Para abrir, use "Nova tela", no topo.',
	},
	// Aviso depois da troca, pelo que ficou gravado: diz até quando a escolha vale
	chegou: {
		nova: 'Pronto: a loja vai abrir na nova tela até você trocar de novo.',
		antiga: `Pronto: a loja vai abrir na tela clássica até ${ULTIMO_DIA_DA_CLASSICA}. Depois, a nova tela passa a ser a padrão.`,
		classica: 'Pronto: a loja vai abrir na tela clássica até você trocar de novo.',
	} as Record<EscolhaDeVersao, string>,
	alteracoes: {
		titulo: (destino: TelaDeLoja) =>
			destino === 'antiga' ? 'Salvar antes de ir para a tela clássica?' : 'Salvar antes de ir para a nova tela?',
		semLista: 'Você alterou esta loja e ainda não salvou.',
		comLista: (quantidade: number) =>
			quantidade === 1 ? 'Há 1 alteração não salva nesta loja:' : `Há ${quantidade} alterações não salvas nesta loja:`,
		abreSalvo: (destino: TelaDeLoja) =>
			destino === 'antiga' ? 'A tela clássica abre com o que estiver salvo.' : 'A nova tela abre com o que estiver salvo.',
		descartar: 'Descartar e trocar',
		continuar: 'Continuar editando',
		salvar: 'Salvar e trocar',
		criar: 'Criar loja e trocar',
		erro: 'A loja não foi salva, então a tela não foi trocada. Confira o campo marcado.',
	},
	erroAoGravar: 'Não foi possível gravar a sua escolha de tela. Tente de novo.',
}
